import { Modal } from 'antd';
import styled from 'styled-components';

import colors from '../../../../../../styles/colors';

export const CustomModal = styled(Modal).attrs({
  okButtonProps: {
    style: {
      background: colors.tmov_green,
      borderColor: colors.tmov_green,
    },
  },
})`
  display: flex;
  flex-direction: column;
`;

export const SelectContainer = styled.div`
  margin-bottom: 24px;

  p {
    margin: 4px 0;
  }

  span {
    font-size: 12px;
    color: ${colors.$greyscale_light_grey_9};
  }
`;
